import { FileQuestionIcon } from "lucide-react"
import { useLocation } from "react-router"
import { ButtonLink, EmptyState, Kbd, PageBody, PageHeader } from "@/design-system/index.ts"
import { useCommandPalette } from "@/layouts/command-palette.tsx"
import { Button } from "@/primitives/button.tsx"

/*
 * An address no page answers, inside the shell, since whoever opened it is signed in (the shell
 * shows sign-in to anyone who isn't). It says which address it was, so a mistyped or out-of-date
 * link is easy to spot, and offers the two ways on: home, which is a link, or the command palette
 * to find what was meant.
 */
export default function NotFound() {
  const { pathname, search, hash } = useLocation()
  const { openPalette } = useCommandPalette()
  return (
    <>
      <PageHeader
        crumbs={[{ label: "Not found", glyph: { kind: "icon", icon: FileQuestionIcon } }]}
      />
      <PageBody width="document">
        <EmptyState
          of={{ listing: "not-found", path: `${pathname}${search}${hash}` }}
          actions={
            <>
              <ButtonLink to="/" size="sm">
                Go home
              </ButtonLink>
              <Button variant="outline" size="sm" onClick={openPalette}>
                Search
                <Kbd shortcut="command-palette" />
              </Button>
            </>
          }
        />
      </PageBody>
    </>
  )
}
